<div class="card">
  <div class="font-medium text-3xl text-900 mb-3">Project Information</div>
  <div class="w-12 flex justify-content-end">
    @if (projectMatch().project.lookingForBetaReaders == true && projectMatch().projectMatchStatus != ProjectMatchStatus.ACTIVE) {
      <div>
        <button pButton pRipple label="I'm Interested" (click)="setInterested()" icon="pi pi-check" class="p-button-text"></button>
      </div>
    }
    @if (projectMatch().project.lookingForBetaReaders == true && projectMatch().projectMatchStatus != ProjectMatchStatus.ACTIVE) {
      <div>
        <button pButton pRipple label="I'm Not Interested" (click)="setNotInterested()" icon="pi pi-times" class="p-button-text align-right"></button>
      </div>
    }
  </div>
  <!-- div class="text-500 mb-5">Morbi tristique blandit turpis. In viverra ligula id nulla hendrerit rutrum.</div -->
  <ul class="list-none p-0 m-0">
    <li class="flex items-center py-3 px-2 border-t-1 surface-border flex-wrap">
      <div class="text-gray-500 w-6 font-medium">Working Title</div>
      <div class="text-gray-900 w-full flex-order-1">{{projectMatch().project.title}}</div>
    </li>
    @for (category of projectMatch().project.profileGroup.profileSelections; track category) {
      <li class="flex items-center py-3 px-2 border-t-1 surface-border flex-wrap">
        <div class="text-500 w-6 md:w-2 font-medium">{{category.enUsLabel}}</div>
        @if (Utils.isArray(category.value)) {
          <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
            @for (tag of category.value; track tag) {
              <span><p-chip [icon]="category.icon?'pi '+category.icon:''" [label]="tag" class="mr-2" /></span>
            }
          </div>
        }
        @if (!Utils.isArray(category.value)) {
          <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
           <span>{{category.descriptorUniqueId}}: {{category.value}}</span>
          </div>
        }
        <div class="w-6 md:w-2 flex justify-content-end">
          <!-- button pButton pRipple label="Edit" icon="pi pi-pencil" class="p-button-text"></button -->
        </div>
      </li>
    }
    <li class="flex items-center py-3 px-2 border-t-1 surface-border flex-wrap">
      <div class="text-gray-500 w-6 font-medium">Author</div>
      <div class="text-gray-900 w-full flex-order-1">{{projectMatch().project.penNameGivenName}}</div>
      <div class="w-6 md:w-2 flex justify-content-end">
        <!-- button pButton pRipple label="Edit" icon="pi pi-pencil" class="p-button-text"></button -->
      </div>
    </li>
    <li class="flex items-center py-3 px-2 border-t-1 border-b-1 surface-border flex-wrap">
      <div class="text-gray-500 w-6 font-medium">Summary</div>
      <div class="text-gray-900 w-full flex-order-1 line-height-3">
      {{projectMatch().project.summary}}</div>
      <div class="w-6 md:w-2 flex justify-content-end">
        <!-- button pButton pRipple label="Edit" icon="pi pi-pencil" class="p-button-text"></button -->
      </div>
    </li>
  </ul>
</div>
